/**
 * @module constants
 */

export default {
  GRAPHIC_TEMPLATE: 'GRAPHIC_TEMPLATE',
  GRAPHIC_MOS_OBJECT: 'GRAPHIC_MOS_OBJECT',
  AUTOMATION: 'AUTOMATION',
  STUDIO_CLIP: 'STUDIO_CLIP',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  SAVED_ITEM: 'SAVED_ITEM'
};



// WEBPACK FOOTER //
// ./app/constants/assetTypes.js